import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  IconButton,
  Paper,
  InputBase,
  Select,
  MenuItem,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useParams } from "react-router-dom";
import { ApiService } from "./ApiService";
import { toast } from "react-toastify";

const ModalClienteEnviarPdf = ({ open, onClose, selectedSucursal, pdfUrl }) => {
	const [search, setSearch] = useState("");
	const [selectedClients, setSelectedClients] = useState([]);
	const [clients, setClients] = useState([]);
	const [tipoCliente, setTipoCliente] = useState("todos");
	const [clientesNormales, setClientesNormales] = useState([]);
	const [clientesMayoristas, setClientesMayoristas] = useState([]);
	const [errorsEnvio, setErrorsEnvio] = useState([]);
	const [isSending, setIsSending] = useState(false);
  
	const { authCode } = useParams();
  
	useEffect(() => {
	  const fetchClientes = async () => {
		try {
		  const normales = await ApiService.fetchData(
			`api/company/clients?key_branch=${selectedSucursal}`,
			{ method: "GET" }
		  );
		  const mayoristas = await ApiService.fetchData(
			`api/company/clients/discount?key_branch=${selectedSucursal}`,
			{ method: "GET" }
		  );
  
		  if (Array.isArray(normales)) setClientesNormales(normales);
		  if (Array.isArray(mayoristas)) setClientesMayoristas(mayoristas);
  
		  // 🟢 Mostrar todos por defecto al abrir
		  const todos = [...(normales || []), ...(mayoristas || [])];
		  const sinDuplicados = todos.filter(
			(cliento, index, self) =>
			  index === self.findIndex((c) => c.phone === cliento.phone)
		  );
		  setClients(sinDuplicados);
		  setTipoCliente("todos");
		} catch (error) {
		  console.error("Error al obtener los clientes:", error);
		}
	  };
  
	  if (authCode) fetchClientes();
	}, [authCode, selectedSucursal]);
  
	const handleAddClient = (client) => {
	  if (!selectedClients.some((c) => c.phone === client.phone)) {
		setSelectedClients((prev) => [...prev, client]);
	  }
	};
  
	const handleTipoChange = (e) => {
	  const tipo = e.target.value;
	  setTipoCliente(tipo);
  
	  if (tipo === "normal") {
		setClients(clientesNormales);
	  } else if (tipo === "mayorista") {
		setClients(clientesMayoristas);
	  } else if (tipo === "todos") {
		const todos = [...clientesNormales, ...clientesMayoristas];
		const sinDuplicados = todos.filter(
		  (obj, index, arr) => arr.findIndex((c) => c.phone === obj.phone) === index
		);
		setClients(sinDuplicados);
	  }
	};
  
	const handleRemoveClient = (phone) => {
	  setSelectedClients((prev) => prev.filter((c) => c.phone !== phone));
	};
  
	const isClientSelected = (phone) =>
	  selectedClients.some((c) => c.phone === phone);
  
	const filteredClients =
	  search.length >= 2
		? clients.filter(
			(client) =>
			  !isClientSelected(client.phone) &&
			  (client.fullName.toLowerCase().includes(search.toLowerCase()) ||
			   client.phone.includes(search))
		  )
		: [];
  
	const handleClearSearch = () => {
	  setSearch("");
	};
  
	const handleSendPdf = async () => {
	  if (!pdfUrl) {
		toast.error("No existe un PDF subido. Genera o sube el PDF primero.");
		return;
	  }
	  if (selectedClients.length === 0) {
		toast.error("Selecciona al menos un cliente.");
		return;
	  }
  
	  setIsSending(true);
	  try {
		const phoneNumbers = selectedClients.map((c) => c.phone);
		const bodyData = {
		  type: "catalogo",
		  url_document: pdfUrl,
		  phone_numers: phoneNumbers,
		};
  
		const response = await ApiService.fetchData(
		  `api/company/clients/send/catalog?key_branch=${selectedSucursal}`,
		  {
			method: "POST",
			headers: {
			  "Content-Type": "application/json",
			},
			body: JSON.stringify(bodyData),
		  }
		);
  
		if (!response) {
		  toast.error("No se recibió respuesta del servidor.");
		  return;
		}
  
		if (response.code === 200) {
		  if (response.errors && response.errors.length > 0) {
			setErrorsEnvio(response.errors);
			toast.warning(`Documento enviado con errores a algunos clientes (ver listado).`);
		  } else {
			toast.success("Documento enviado exitosamente a todos los clientes.");
		  }
		} else {
		  toast.error("Error en el envío: " + response.message);
		}
	  } catch (error) {
		console.error("Error al enviar PDF:", error);
		toast.error("No se pudo enviar el PDF");
	  } finally {
		setIsSending(false);
	  }
	};
  
	return (
	  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
		<DialogTitle
		  sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
		>
		  <Box display="flex" alignItems="center" gap={2}>
			<Typography variant="h6">Clientes</Typography>
			<Select size="small" value={tipoCliente} onChange={handleTipoChange}>
			  <MenuItem value="todos">Todos</MenuItem>
			  <MenuItem value="normal">Normal</MenuItem>
			  <MenuItem value="mayorista">Mayorista</MenuItem>
			</Select>
		  </Box>
		  <IconButton size="small" onClick={onClose}>
			<CloseIcon />
		  </IconButton>
		</DialogTitle>
  
		<DialogContent>
		  <Box
			sx={{
			  display: "flex",
			  alignItems: "center",
			  border: "1px solid #000",
			  borderRadius: 20,
			  px: 1,
			  mb: 2,
			}}
		  >
			<SearchIcon sx={{ fontSize: "24px", mr: 1 }} />
			<InputBase
			  placeholder="Buscar cliente"
			  fullWidth
			  value={search}
			  onChange={(e) => setSearch(e.target.value)}
			  sx={{ flex: 1 }}
			/>
			{search && (
			  <IconButton size="small" onClick={handleClearSearch}>
				<ClearIcon fontSize="small" />
			  </IconButton>
			)}
		  </Box>
  
		  {/* Lista con scroll de todos los clientes (no seleccionados aún) */}
		  <Paper
			elevation={3}
			sx={{
			  mb: 2,
			  maxHeight: 250,
			  overflowY: "auto",
			  border: "1px solid #ddd",
			  borderRadius: 1,
			  p: 1,
			}}
		  >
			{(search.length < 2 ? clients : filteredClients).map((client) => (
			  !isClientSelected(client.phone) && (
				<Box
				  key={client.phone}
				  display="flex"
				  justifyContent="space-between"
				  alignItems="center"
				  sx={{
					borderBottom: "1px solid #eee",
					py: 1,
					cursor: "pointer",
					"&:hover": { backgroundColor: "#f5f5f5" },
				  }}
				  onClick={() => handleAddClient(client)}
				>
				  <Typography>{client.fullName}</Typography>
				  <Typography variant="body2" color="text.secondary">
					{client.phone}
				  </Typography>
				</Box>
			  )
			))}
		  </Paper>
  
		  {/* Tabla de clientes seleccionados */}
		  <Box maxHeight={300} overflow="auto">
			<Table size="small">
			  <TableHead>
				<TableRow>
				  <TableCell><strong>NOMBRE</strong></TableCell>
				  <TableCell><strong>NUMERO</strong></TableCell>
				  <TableCell><strong>ACCIÓN</strong></TableCell>
				</TableRow>
			  </TableHead>
			  <TableBody>
				{selectedClients.map((client) => {
				  const hasError = errorsEnvio.includes(client.phone);
				  return (
					<TableRow
					  key={client.phone}
					  sx={{ backgroundColor: hasError ? "#fdd" : "transparent" }}
					>
					  <TableCell>{client.fullName}</TableCell>
					  <TableCell>{client.phone}</TableCell>
					  <TableCell>
						<IconButton
						  size="small"
						  color="error"
						  onClick={() => handleRemoveClient(client.phone)}
						>
						  <DeleteIcon />
						</IconButton>
					  </TableCell>
					</TableRow>
				  );
				})}
			  </TableBody>
			</Table>
		  </Box>
		</DialogContent>
  
		<DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
		  <Button variant="outlined" onClick={onClose}>
			Cerrar
		  </Button>
		  <Button
			variant="contained"
			startIcon={<WhatsAppIcon />}
			sx={{ background: "#54b209" }}
			onClick={handleSendPdf}
			disabled={isSending}
		  >
			{isSending ? "Preparando Pdf para enviar" : "Enviar"}
		  </Button>
		</DialogActions>
	  </Dialog>
	);
  };
  

export default ModalClienteEnviarPdf;
